import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAdminComponent } from '../components/create-admin/create-admin.component';
import { DataSharedService } from '../services/data-shared.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  constructor(private modalService: NgbModal,
    public dataSharedService: DataSharedService,
  ) { }

  ngOnInit(): void {
  }

  onAdd() {
    const modalRef = this.modalService.open(CreateAdminComponent, {
      size: 'lg',
      modalDialogClass: 'add-candidate-modal',
      backdrop: "static",
      keyboard: false,
      centered: true,
    });
    modalRef.result.then((data) => {
      if (data?.refresh === true) {
        this.dataSharedService.sendUpdate('Updated Active Admin');
      }
    });

  }

}
